import { useAuthStore } from '@/store/auth';
import { useModuleStore } from '@/store/module';
import { removeToken } from '@/utils/cookies';
import { ensureGroupPermissions } from '@/middleware/checkPermission';

export default async ({ to, from, next }) => {
  const { token, credentials, user, getUser } = useAuthStore();
  const { modules, getModules } = useModuleStore();

  // Allow access to Unauthorized route regardless of auth state
  if (to.name === 'Unauthorized' || to.path === '/unauthorized') {
    return next();
  }

  const publicRoutes = ['/login', '/reset-password'];
  if (publicRoutes.some((route) => to.path.startsWith(route))) {
    if (to.path.startsWith('/reset-password')) {
      removeToken();
      removeToken(true);
    }
    return next();
  }

  if (!token) {
    // Allow access to OTP page if user has credentials, otherwise redirect to login
    if (to.path === '/otp' && credentials) {
      return next();
    }
    return next({ path: '/login', replace: true });
  } else {
    if (user === null) {
      await getUser();
    }
    if (modules.length == 0) {
      await getModules();
    }

    await ensureGroupPermissions(useAuthStore().user);

    if (to.path === '/otp' || to.path === '/login' || to.path === '/') {
      return next({ name: 'Home' });
    }
  }
  return next();
};
